// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class ExtLinkUtils {
    constructor() { }
    static getEmbedYouTubeLinkByVideoID(videoId) {
        const linkPrefix = 'https://www.youtube.com/embed/';
        return linkPrefix + videoId;
    }
    static getVideoIDFromYouTubeLink(url) {
        if (!url) {
            return null;
        }
        const videoIdRegex = /(?:v=|\/)([\w-]{11})(?:[\?&][\w\.-=]*)?/;
        let match = url.match(videoIdRegex);
        if (match) {
            return match[1];
        }
        const liveIdRegex = /\/live\/(\w+)/;
        match = url.match(liveIdRegex);
        if (match) {
            return match[1];
        }
        return null;
    }
    static sortYoutubeLinks(items) {
        const sortedItems = items.sort((link1, link2) => {
            var _a, _b, _c, _d;
            // Stream online comparison
            if (link1.config.getStreamOnline() || link2.config.getStreamOnline()) {
                if (link1.config.getStreamOnline() && link2.config.getStreamOnline()) {
                    const startDate1 = link1.config.getStreamStartDate();
                    const startDate2 = link2.config.getStreamStartDate();
                    if (startDate1 && startDate2) {
                        return startDate1 > startDate2 ? -1 : 1;
                    }
                }
                else if (link1.config.getStreamOnline()) {
                    return -1;
                }
                else if (link2.config.getStreamOnline()) {
                    return 1;
                }
            }
            // Upcoming stream comparison
            const upLiveStream1 = link1.liveStream && link1.config.getStreamEndDate() === null;
            const upLiveStream2 = link2.liveStream && link2.config.getStreamEndDate() === null;
            if (upLiveStream1 || upLiveStream2) {
                if (upLiveStream1 && upLiveStream2) {
                    const createDate1 = (_a = link1.config.getStreamStartDate()) !== null && _a !== void 0 ? _a : link1.config.getVideoCreateDate();
                    const createDate2 = (_b = link2.config.getStreamStartDate()) !== null && _b !== void 0 ? _b : link2.config.getVideoCreateDate();
                    if (createDate1 && createDate2) {
                        return createDate1 < createDate2 ? -1 : 1;
                    }
                }
                else if (upLiveStream1) {
                    return -1;
                }
                else if (upLiveStream2) {
                    return 1;
                }
            }
            // Completed stream & video comparison
            const date1 = (_c = link1.config.getStreamEndDate()) !== null && _c !== void 0 ? _c : link1.config.getVideoCreateDate();
            const date2 = (_d = link2.config.getStreamEndDate()) !== null && _d !== void 0 ? _d : link2.config.getVideoCreateDate();
            if (date1 && date2) {
                return date1 > date2 ? -1 : 1;
            }
            return 0;
        });
        return sortedItems;
    }
    // Show date if needed for a YoutubeLinkTool
    static showDateIfNeeded(tool) {
        if (tool.config.getStreamStartDate() === null || tool.config.getStreamEndDate() !== null || !tool.liveStream) {
            return false;
        }
        return true;
    }
}
